import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores';
import { Loader2 } from 'lucide-react';
import { Navbar } from '../../components/layout/navbar';

export default function ProfileRedirect() {
  const navigate = useNavigate();
  const { walletAddress } = useAuthStore();

  useEffect(() => {
    if (walletAddress) {
      // Preserve query parameters (like ?from=discussionOid)
      const searchParams = window.location.search;
      navigate(`/profile/${walletAddress}${searchParams}`, {
        replace: true,
      });
    }
  }, [walletAddress, navigate]);

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="flex justify-center items-center h-96">
        <div className="text-center">
          <Loader2 className="animate-spin h-12 w-12 text-purple-500 mx-auto mb-4" />
          <p className="text-zinc-400 font-medium">Loading profile...</p>
        </div>
      </div>
    </div>
  );
}
